// theme.js
// Mobile menu, scroll fade-in, and the inquiry box.
// The form itself is Shopify's contact form, so a normal submit sends the email.

var toggle = document.getElementById("nav-toggle");
var nav = document.getElementById("site-nav");
if (toggle && nav) {
  toggle.addEventListener("click", function () {
    nav.classList.toggle("open");
  });
}

var observer = new IntersectionObserver(
  function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.12 }
);
document.querySelectorAll(".reveal").forEach(function (el) {
  observer.observe(el);
});

var wholesaleModal = document.getElementById("wholesale-modal");
var wholesaleOpenButtons = document.querySelectorAll(".open-wholesale");
var wholesaleForm = document.getElementById("wholesale-form");
// Ask Shopify to attach its spam check as soon as the page loads.
// Without this, the first click is swallowed and the message box changes.
if (wholesaleForm) {
  wholesaleForm.setAttribute("data-shopify-captcha", "true");
}
if (wholesaleModal && wholesaleOpenButtons.length > 0) {
  var wholesaleSource = document.getElementById("wholesale-source");
  var wholesaleLastOpener = null;

  function openWholesale(event) {
    wholesaleLastOpener = event.currentTarget;
    if (wholesaleSource) {
      wholesaleSource.value = wholesaleLastOpener.getAttribute("data-source") || "";
    }
    var bundleNote = wholesaleLastOpener.getAttribute("data-bundle") || "";
    var messageField = document.getElementById("wholesale-message");
    if (messageField && bundleNote !== "") {
      messageField.value = bundleNote;
    }
    wholesaleModal.hidden = false;
    document.body.style.overflow = "hidden";
    var nameField = document.getElementById("wholesale-name");
    if (nameField) {
      nameField.focus();
    }
  }

  function closeWholesale() {
    wholesaleModal.hidden = true;
    document.body.style.overflow = "";
    if (wholesaleLastOpener) {
      wholesaleLastOpener.focus();
    }
  }

  wholesaleOpenButtons.forEach(function (button) {
    button.addEventListener("click", openWholesale);
  });
  wholesaleModal.querySelectorAll("[data-close-modal]").forEach(function (button) {
    button.addEventListener("click", closeWholesale);
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !wholesaleModal.hidden) {
      closeWholesale();
    }
  });
}

function showView(name) {
  var views = document.querySelectorAll(".site-view");
  if (!name) {
    name = "home";
  }
  var shown = null;
  views.forEach(function (view) {
    var on = view.getAttribute("data-view") === name;
    view.hidden = !on;
    if (on) {
      shown = view;
    }
  });
  if (!shown) {
    views.forEach(function (view) {
      var on = view.getAttribute("data-view") === "home";
      view.hidden = !on;
      if (on) {
        shown = view;
      }
    });
  }
  if (shown) {
    shown.querySelectorAll(".reveal").forEach(function (el) {
      el.classList.add("visible");
    });
  }
  window.scrollTo(0, 0);
  if (nav) {
    nav.classList.remove("open");
  }
}

window.addEventListener("hashchange", function () {
  showView(window.location.hash.replace("#", ""));
});

if (document.querySelector(".site-view")) {
  showView(window.location.hash.replace("#", ""));
}
